import { render, staticRenderFns } from "./DateRange.vue?vue&type=template&id=35f4b038&scoped=true&"
import script from "./DateRange.vue?vue&type=script&lang=js&"
export * from "./DateRange.vue?vue&type=script&lang=js&"
import style0 from "./DateRange.vue?vue&type=style&index=0&id=35f4b038&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f4b038",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35f4b038')) {
      api.createRecord('35f4b038', component.options)
    } else {
      api.reload('35f4b038', component.options)
    }
    module.hot.accept("./DateRange.vue?vue&type=template&id=35f4b038&scoped=true&", function () {
      api.rerender('35f4b038', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2gdP56BNGYwNU/JS/comp/DateRange.vue"
export default component.exports